const TOKEN_KEY = 'driver_learning_token'

/**
 * 获取 token
 */
export function getToken() {
    return localStorage.getItem(TOKEN_KEY)
}

/**
 * 保存 token
 */
export function setToken(token) {
    localStorage.setItem(TOKEN_KEY, token)
}

/**
 * 删除 token
 */
export function removeToken() {
    localStorage.removeItem(TOKEN_KEY)
}